import { IJddAddress } from '../../interfaces/Address'

export const DefaultJddAddress: IJddAddress = {
  adresse_batiment: '',
  adresse_rue: '',
  adresse_bp: '',
  adresse_cp: '',
  adresse_ville: '',
  adresse_pays: '',
  commune_habitation: '',
}
